import qs from 'qs';

/**
 * Returns a query string prepended by a "?"
 */
export default function qsStringify(
  query?: Record<string, any> | undefined | null,
  options: qs.IStringifyOptions = {},
) {
  if (!query) {
    return '';
  }

  return qs.stringify(query, {
    addQueryPrefix: true,
    arrayFormat: 'brackets',
    skipNulls: true,
    ...options,
  });
}
